import { Flex, Grid, Spinner, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMoralisQuery } from 'react-moralis';
import { Outlet } from 'react-router-dom';
import { ContentContainer } from 'src/components/common/ContentContainer/contentContainer';
import { GamePanel } from 'src/components/common/GamePanel/gamePanel';
import { PageDescription } from 'src/components/common/PageDescription/pageDescription';
import { useBlockchainProvider } from 'src/providers/Blockchain/blockchainProvider';
import { customWidths } from 'src/utils/constants';
import { CreatorMenu } from './CreatorMenu/creatorMenu';

export const containerStyle = {};

export interface GamePanelItem {
	id: string;
	cartridgeAddress: string;
	name: string;
	symbol: string;
	logoUrl: string;
	price: string;
	listed: boolean;
	patchkitAppId?: string;
	platforms: string[];
	genres: string[];
	colors: any;
	creator: string;
	screenshots: string[];
	marketplaceFee: string | null
}

export const Creator = () => {
	const { t } = useTranslation();
	const { account, isChainValid } = useBlockchainProvider();

	const { data, error, isLoading } = useMoralisQuery('Games', query =>
		query.equalTo('creator', account.toLowerCase())
	);

	const [games, setGames] = useState<GamePanelItem[]>([]);

	useEffect(() => {
		if (data.length > 0) {
			const mapped = data.map(el => ({
				id: el.id,
				cartridgeAddress: el.attributes.address,
				symbol: el.attributes.symbol,
				name: el.attributes.name,
				logoUrl: el.attributes.media.logoUrl,
				price: el.attributes.price,
				listed: el.attributes.listed,
				creator: el.attributes.creator,
				patchkitAppId: el.attributes.patchkitAppId,
				platforms: el.attributes.platforms,
				colors: el.attributes.colors,
				screenshots: el.attributes.screenshots,
				genres: el.attributes.genres,
				marketplaceFee: el.attributes.marketplaceFee
			}));
			console.log(mapped)
			setGames(mapped);
		}
	}, [data]);

	return (
		<ContentContainer>
			<Grid
				w="100%"
				templateColumns="230px auto"
				gap="10px"
			>
				<Grid>
					<CreatorMenu />
				</Grid>
				<Grid
					position="relative"
					borderLeft="1px solid"
					borderLeftColor="#414141"
					paddingLeft="50px"
				>
					<Outlet />
				</Grid>
			</Grid>
		</ContentContainer>
	);
};
